
<div class="title">Select an amount for donation</div>
<div class="slab-wrapper">
  <form [formGroup]="amountForm">
    <div class="input" [ngClass]="{'error': amount.invalid, 'touched': touched && !amount.invalid}" (click)="focus()">
      <div class="currencyicon"><app-currency-icon *ngIf="config?.currency" [currency]="config?.currency"></app-currency-icon></div>
      <input id="amount-input" matInput type="number" #amountRef class="other-input" formControlName="amount" [min]="config?.contributeDetails?.min_donation || 0">
      <div id="amount-animation" class="amount-animation">+{{slabAmount_clicked}}</div>
    </div>
    <div *ngIf="amount.invalid" class="other-error">
      <div *ngIf="amount.hasError('required')">{{'Stories.bankTransfer.requiredField' | translatePipe | async}}</div>
      <div *ngIf="amount.hasError('pattern')">Invalid Amount</div>
      <div *ngIf="amount.hasError('min')">
        {{'Stories.bankTransfer.valueGreaterValidation' | translatePipe | async}}
        <app-currency-icon *ngIf="config?.currency" [currency]="config?.currency"></app-currency-icon> {{config?.contributeDetails?.min_donation}}.
      </div>
      <div *ngIf="amount.hasError('max')">Please enter a value less than or equal to <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{max_donation}}.</div>
    </div>
    <div *ngIf="!amount?.invalid && config?.params?.mini_story" class="tax-nudge">Bigger the donation, bigger your tax savings</div>
    <div class="slabs-btns">
      <button mat-button class="slab" *ngFor="let slab of slab_amount" (click)="addAmount(slab)">
        +{{slab}}
      </button>
    </div>
  </form>
</div>